const STORAGE_KEY = "gx_cookie_consent";

export const DEFAULT_CONSENT = {
  essential: true,
  analytics: false,
  marketing: false,
};

export function getConsent() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object" || !parsed.categories) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function saveConsent(categories) {
  const record = {
    categories: { ...DEFAULT_CONSENT, ...categories, essential: true },
    timestamp: new Date().toISOString(),
    version: 1,
  };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(record));
  window.dispatchEvent(new CustomEvent("gx-cookie-consent-updated", { detail: record }));
  return record;
}

export function resetConsent() {
  localStorage.removeItem(STORAGE_KEY);
  window.dispatchEvent(new CustomEvent("gx-cookie-consent-updated", { detail: null }));
}

// Reopen the cookie preferences modal on demand (e.g. from a footer link).
export function openCookiePreferences() {
  window.dispatchEvent(new CustomEvent("gx-open-cookie-preferences"));
}

// Central place to check a category before firing any tracking script.
export function isCategoryAllowed(category) {
  const consent = getConsent();
  if (!consent) return category === "essential";
  return !!consent.categories?.[category];
}
